module.exports = __webpack_public_path__ + "img/Weapon_112.58f42a69.png";